/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AuthSettingsModule
 */

import { IAuthMatchGroupMembership } from 'generated-types';
import { AuthMatchGroupMembership } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * @description AuthMatchGroupMembership ConfigItem class.
 *
 * @author Aravindh Nagarajan
 */
export class AuthMatchGroupMembershipConfigItem extends MessageItem<IAuthMatchGroupMembership> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: AuthMatchGroupMembership,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Returns true if criteria is defined.
     */
    public get hasCriteria(): boolean {
        return Boolean(this.config.criteria);
    }
}
